import { render, staticRenderFns } from "./Login-v2.vue?vue&type=template&id=71d15916&scoped=true&"
import script from "./Login-v2.vue?vue&type=script&lang=js&"
export * from "./Login-v2.vue?vue&type=script&lang=js&"
import style0 from "./Login-v2.vue?vue&type=style&index=0&id=71d15916&scoped=true&lang=css&"
import style1 from "./Login-v2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d15916",
  null
  
)

export default component.exports